// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"8a009e51","119":"93fe0d7b","133":"0649044e","453":"6fdfc97a","719":"0571f508","989":"f10c9a98"}[chunkId] + ".chunk.js";
};